import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function PropertytypeTownhouseOutlineIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M13 5.52228V1.52344L2.88477 5.56836C1.74024 6.02734 1 7.12012 1 8.35449V22H23V1.52344L13 5.52228ZM11 20H8V17H6V20H3V8.35449C3 7.94336 3.24707 7.57812 3.62793 7.42578L11 4.47656V20ZM21 20H18V17H16V20H13V8.35449C13 7.94336 13.2471 7.57812 13.6279 7.42578L21 4.47656V20ZM5 11H9V13H5V11ZM19 13H15V11H19V13Z",
    fill: "currentColor"
  }));
}